import moment from "moment";

angular.module("events")

.filter('toLocalDate', function () {
    return function (dateUTCString) {
        //YYYY-MM-DDTHHmm:ss
        if (dateUTCString != null)
            return new Date(dateUTCString);
        return dateUTCString;
    };
})
    .filter('toUniversalDateCreatedAtHack', function () {
        return function (dateUniversalString) {
            //YYYY-MM-DDTHHmm:ss
            //hack porque el created_at en la base de datos es local y lo devuelve como utc y entonces sale una hora mal.
            if (dateUniversalString != null) {
                return moment(dateUniversalString).add(-1, 'hours').toDate();
            }
            return dateUniversalString;
        };
    })
